<script setup>
import menus from "@/configs/menu";

const emits = defineEmits(['hamburgerClick'])
const clickMobileMenu = () => {
  emits('hamburgerClick');
}
const utm = useUtm();
const queryUtmParameters = ref('');
onMounted(() => {
  queryUtmParameters.value = utm.getQueryUtmParameters();
})
</script>

<template>
  <div class="w-full bg-white">
    <div class="flex justify-between items-center border-b border-b-gray-200 py-2">
      <div class="hidden md:block">
      </div>
      <div class="flex gap-6 justify-between xl:justify-normal w-full md:w-auto">
        <div class="flex gap-6 w-full xl:w-auto">
          <ButtonSwitch class="md:hidden"/>
          <ButtonCompare class="ml-auto lg:ml-0"/>
          <MenuItem :href="'/moto'">
            <VectorMoto />
          </MenuItem>
          <MenuItem v-for="menu in menus" :href="menu.path">{{ menu.label }}</MenuItem>
          <IconHamburger class="lg:hidden" @click="clickMobileMenu"/>
        </div>
      </div>
    </div>
  </div>
</template>
